module.exports = { "default": require("core-js/library/fn/object/freeze"), __esModule: true };


/*****************
 ** WEBPACK FOOTER
 ** ./~/babel-runtime/core-js/object/freeze.js
 ** module id = 82
 ** module chunks = 1
 **/